import {
  getPromotionCatalogList,
  getPromotionPath,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { promotionActions } from "../reducers/promotion";
import { t } from "i18next";
import { toast } from "react-toastify";

export const fetchPromotionList = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getPromotionPath(id))
      .then((response) => {
        if (id === 0) {
          dispatch(promotionActions.fetchPromotionList(response.data));
        } else {
          dispatch(promotionActions.fetchPromotionDetail(response.data));
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchPromotionCatalogList = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(getPromotionCatalogList(id))
      .then((response) => {
        dispatch(promotionActions.fetchPromotionCatalogList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("security.error.refresh"), { theme: "colored" });
  }
  toast.error(errorMessage, { theme: "colored" });
};
